import React from "react";

export type YhContainerSize = "sm" | "md" | "lg" | "xl" | "full" | "auth";

export interface YhContainerProps {
  children: React.ReactNode;
  /** max width preset — uses global CSS in index.css */
  size?: YhContainerSize;
  className?: string;
  as?: keyof React.JSX.IntrinsicElements;
}

/**
 * Global layout container — responsive max-width from index.css.
 * - default / xl → .yh-container (screen-wise max-width)
 * - auth → .yh-container-auth (full viewport for login)
 * - full → no max-width
 */
export const YhContainer: React.FC<YhContainerProps> = ({
  children,
  size = "xl",
  className = "",
  as: Tag = "div",
}) => {
  const baseClass =
    size === "auth"
      ? "yh-container-auth"
      : size === "full"
      ? "w-full"
      : "yh-container";

  return React.createElement(
    Tag,
    { className: `${baseClass} ${className}`.trim() },
    children
  );
};

export default YhContainer;
